import React from 'react';
import { MOCKUP_IMAGE, OFFER_ANCHOR, PRODUCT } from '../data/constants';
interface MockupImageProps {
  className?: string;
  priority?: boolean;
}
export function MockupImage({
  className,
  priority = false
}: MockupImageProps) {
  return <a href={OFFER_ANCHOR} aria-label={`Go to the ${PRODUCT} offer`} className={`block ${className ?? ''}`} data-id="element-100" data-mp="2vtq3f28g7n3a">
      <img src={MOCKUP_IMAGE} alt={`${PRODUCT} — complete 6-in-1 box set of appliance diagnostic modules`} loading={priority ? 'eager' : 'lazy'} className="mx-auto w-full max-w-[340px] drop-shadow-xl sm:max-w-md" data-id="element-101" data-mp="2mumlw2oxjfqw" />
    </a>;
}